<div class="padre" style="z-index:1001;background-color: white;position: absolute;top: 0;width:100%;height: 100%;">
    <div class="container hijo">
        <div class="row justify-content-center">
            <div class="col-md-12 text-center">
                <span class="display-1 d-block">503 - Service unavailable</span>
                <div class="mb-4 lead">Service temporarily unavailable. Try again later</div>
                <div *ngIf="showFailedUrl()" class="mb-4">
                    <p class="fw-bold text-break">{{ failedUrl }}</p>
                </div>
            </div>
        </div>
    </div>
</div>
